import { hook } from './xhr-hook';
import { isApp } from '@bbtfe/utils';
import { getFirstScreenTime } from './fst';
/**
 * 前端监控sdk
 */
var parseURL = function e(r) {
  var n = document.createElement('a');
  n.href = r;
  return n;
};

var parseUrlQuery = function e(r) {
  var n = parseURL(r).search;
  n = n.slice(1);
  var i = {};
  n.split('&').forEach(function (e) {
    var r = e.split('='),
      n = r[0],
      t = r[1];
    i[n] = decodeURIComponent(typeof t === 'undefined' ? '' : t);
  });
  return i;
};

var serialize = function (e) {
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) &&
      t.push(encodeURIComponent(n) + '=' + encodeURIComponent(e[n]));
  return t.join('&');
};

var W = window;
var WN = W.navigator;
var WP = W.performance;

var bbtMonitor = {
  init: function (options = {}) {
    var ua = WN.userAgent;
    var href = W.location.href;
    const query = parseUrlQuery(href);
    this.base = {
      projectId: query['babytree-app-id'] || 'pregnancy',
      uId: query['enc-user-id'] || 'unknown',
      url: encodeURIComponent(href),
      extra: JSON.stringify({
        ua
      }),
      babytree_client_type: /android/i.test(ua)
        ? 'Android'
        : /iPad|iPhone|iPod/.test(ua)
        ? 'iOS'
        : /windows/i.test(ua)
        ? 'Windows'
        : 'unknown',
      babytree_app_version: query['babytree-app-version'] || 'unknown',
      ...options
    };
    this.errorEvent();
  },
  config: function (options = {}) {
    this.base = {
      ...this.base,
      ...options
    };
  },
  getData: function (data = {}) {
    return {
      ...this.base,
      ...data
    };
  },
  sendByImage: function (url, data) {
    var img = new Image(1, 1);
    img.onload = function () {
      img = null;
    };
    img.onerror = function () {
      img = null;
    };
    img.src = `${url}?${serialize(data)}`;
  },
  send: function (url, data) {
    if ('requestIdleCallback' in W) {
      var self = this;
      W.requestIdleCallback(function () {
        self.sendByImage(url, data);
      });
    } else {
      this.sendByImage(url, data);
    }
  },
  sendError: function (data = {}) {
    if (this.filterError(data) == true) return;
    this.send('//m.babytree.com/monitor/bad.gif', this.getData(data));
  },
  catchError: function (msg, stack) {
    this.sendError({
      msg,
      stack
    });
  },
  filterError: function (data = {}) {
    const { msg, filename } = data;
    if (!msg) return true;
    // 主要针对app主动调用的js
    if (!filename && msg == 'Script error.') return true;
    if (msg) {
      const msgBlackList = [
        'webviewAppear',
        'webviewDisappear',
        'onNetStateChange',
        'pageLoadFinish',
        'notifyH5MoveMentPlayStatusCallBack'
      ];
      for (var i = 0; i < msgBlackList.length; i++) {
        if (msg.indexOf(msgBlackList[i]) > -1) return true;
      }
    }
    if (filename) {
      const filenameBlackList = ['t.kexin001.com', 'bid.babytree.com'];
      for (var j = 0; j < filenameBlackList.length; j++) {
        if (filename.indexOf(filenameBlackList[j]) > -1) return true;
      }
    }
    return false;
  },
  errorEvent: function () {
    var self = this;
    var onError = function (event) {
      var data = {};
      var target = event.target;
      if (target && target.nodeName) {
        data.msg = target.nodeName.toLowerCase() + '标签资源加载失败';
        data.filename = target.src || target.href || '';
      } else {
        data.msg = event.message || '';
        data.filename = event.filename || '';
        data.row = event.lineno || '';
        data.column = event.colno || '';
        data.stack = event.error && event.error.stack ? event.error.stack : '';
      }
      self.sendError(data);
    };
    var onUnhandledrejection = function (event) {
      var reason = event.reason;
      self.sendError({
        msg: reason.message || 'unhandledrejection',
        stack: reason.stack || ''
      });
    };
    W.addEventListener('error', onError, true);
    W.addEventListener('unhandledrejection', onUnhandledrejection, true);
  },
  /**
   * navigationStart 表征了从同一个浏览器上下文的上一个文档卸载(unload)结束时的UNIX时间戳。如果没有上一个文档，这个值会和PerformanceTiming.fetchStart相同
   * redirectStart 表征了第一个HTTP重定向开始时的UNIX时间戳。如果没有重定向，或者重定向中的一个不同源，这个值会返回0
   * redirectEnd 表征了最后一个HTTP重定向完成时（也就是说是HTTP响应的最后一个比特直接被收到的时间）的UNIX时间戳。如果没有重定向，或者重定向中的一个不同源，这个值会返回0.
   * fetchStart 表征了浏览器准备好使用HTTP请求来获取(fetch)文档的UNIX时间戳。这个时间点会在检查任何应用缓存之前。
   * domainLookupStart 表征了域名查询开始的UNIX时间戳。如果使用了持续连接(persistent connection)，或者这个信息存储到了缓存或者本地资源上，这个值将和 PerformanceTiming.fetchStart一致。
   * domainLookupEnd 表征了域名查询结束的UNIX时间戳。如果使用了持续连接(persistent connection)，或者这个信息存储到了缓存或者本地资源上，这个值将和 PerformanceTiming.fetchStart一致。
   * connectStart 返回HTTP请求开始向服务器发送时的Unix毫秒时间戳。如果使用持久连接（persistent connection），则返回值等同于fetchStart属性的值
   * (secureConnectionStart) 返回浏览器与服务器开始安全链接的握手时的Unix毫秒时间戳。如果当前网页不要求安全连接，则返回0
   * connectEnd 返回浏览器与服务器之间的连接建立时的Unix毫秒时间戳。如果建立的是持久连接，则返回值等同于fetchStart属性的值。连接建立指的是所有握手和认证过程全部结束
   * requestStart 返回浏览器向服务器发出HTTP请求时（或开始读取本地缓存时）的Unix毫秒时间戳
   * responseStart 返回浏览器从服务器收到（或从本地缓存读取）第一个字节时的Unix毫秒时间戳。如果传输层在开始请求之后失败并且连接被重开，该属性将会被数制成新的请求的相对应的发起时间
   * responseEnd 返回浏览器从服务器收到（或从本地缓存读取，或从本地资源读取）最后一个字节时（如果在此之前HTTP连接已经关闭，则返回关闭时）的Unix毫秒时间戳
   * domLoading 返回当前网页DOM结构开始解析时（即Document.readyState属性变为“loading”、相应的 readystatechange (en-US)事件触发时）的Unix毫秒时间戳
   * domInteractive 返回当前网页DOM结构结束解析、开始加载内嵌资源时（即Document.readyState属性变为“interactive”、相应的readystatechange (en-US)事件触发时）的Unix毫秒时间戳
   * domContentLoadedEventStart 返回当解析器发送DOMContentLoaded (en-US) 事件，即所有需要被执行的脚本已经被解析时的Unix毫秒时间戳
   * domContentLoadedEventEnd 返回当所有需要立即执行的脚本已经被执行（不论执行顺序）时的Unix毫秒时间戳
   * domComplete 返回当前文档解析完成，即Document.readyState 变为 'complete'且相对应的readystatechange (en-US) 被触发时的Unix毫秒时间戳
   * loadEventStart 返回该文档下，load (en-US)事件被发送时的Unix毫秒时间戳。如果这个事件还未被发送，它的值将会是0
   * loadEventEnd 返回当load (en-US)事件结束，即加载事件完成时的Unix毫秒时间戳。如果这个事件还未被发送，或者尚未完成，它的值将会是0
   * unloadEventStart 表征了unload (en-US)事件抛出时的UNIX时间戳。如果没有上一个文档，or if the previous document, or one of the needed redirects, is not of the same origin, 这个值会返回0
   * unloadEventEnd 表征了unload (en-US)事件处理完成时的UNIX时间戳。如果没有上一个文档，or if the previous document, or one of the needed redirects, is not of the same origin, 这个值会返回0.
   */
  // https://developers.google.com/web/fundamentals/performance/navigation-and-resource-timing?hl=zh-cn#requests_and_responses
  getWP: function () {
    var timing = WP.timing;
    var connection = WN.connection;
    var data = {
      ect:
        connection && connection.effectiveType
          ? connection.effectiveType
          : 'unkown',
      /* 网络相关指标 */
      dns: timing.domainLookupEnd - timing.domainLookupStart, // DNS 查询耗时

      tcp: timing.connectEnd - timing.connectStart, // TCP建立连接时间
      ssl:
        timing.secureConnectionStart > 0
          ? timing.connectEnd - timing.secureConnectionStart
          : 0, // TLS时间

      ttfb: timing.responseStart - timing.requestStart, // request 耗时 Time to First Byte (TTFB)
      download: timing.responseEnd - timing.responseStart, // response结束 耗时 Response time only (download)

      /* dom相关 */
      domLoading: timing.domLoading - timing.navigationStart, // 浏览器开始解析dom时间

      /* 总时间 */
      fst: timing.domContentLoadedEventStart - timing.navigationStart, // 首屏时间

      domComplete: timing.domComplete - timing.navigationStart, // dom解析完成，并且dom内所有内嵌资源也加载完成

      load: timing.loadEventEnd - timing.navigationStart // 加载时间
    };
    if (WP.getEntriesByName) {
      var fpPMT = WP.getEntriesByName('first-paint')[0];
      if (fpPMT) {
        data.fp = parseInt(fpPMT.startTime);
      }
      var fcPMT = WP.getEntriesByName('first-contentful-paint')[0];
      if (fcPMT) {
        data.fcp = parseInt(fcPMT.startTime);
      }
    }
    return data;
  },
  performanceEvent: function (callback) {
    if (!WP) return;
    var self = this;
    var newCallback = function (data) {
      if (callback && callback(data) === false) return;
      if (!data.load || data.load < 0) return;
      self.send('//monitor.babytree.com/v1.jpg', self.getData(data));
    };
    if (WP.timing.loadEventEnd > 0 || document.readyState === 'complete') {
      newCallback(self.getWP());
    } else {
      var onLoad = function () {
        W.setTimeout(function () {
          newCallback(self.getWP());
        }, 1000);
        W.removeEventListener('load', onLoad);
        onLoad = null;
      };
      W.addEventListener('load', onLoad, true);
    }
  },
  APIEvent: function (callback) {
    var self = this;
    const RECORD_KEY = '@bbtfe/bbt-monitor';
    const set = function (xhr, key, value) {
      if (!xhr[RECORD_KEY]) {
        xhr[RECORD_KEY] = {};
      }
      xhr[RECORD_KEY][key] = value;
    };
    const getData = function (xhr) {
      if (!xhr[RECORD_KEY]) return false;
      const cacheData = xhr[RECORD_KEY] || {};
      const { doneTime, sendTime, open_args } = cacheData;
      const duation = doneTime - sendTime || 0;
      const [method, url] = open_args;
      const connection = WN.connection;
      const data = {
        ect:
          connection && connection.effectiveType
            ? connection.effectiveType
            : 'unkown',
        ...cacheData,
        method: method.toLowerCase(),
        url: parseURL(url).href,
        duation,
        timeout: xhr.timeout || 0,
        status: xhr.status || 0
      };
      delete data.open_args;
      return data;
    };
    let lastSend = null;
    let lastUrl = null;
    const LOCKTIME = 1000;
    var newCallback = function (data) {
      if (callback && callback(data) === false) return;
      // 为了避免有些业务封装请求重试的机制，设定相同url的请求，1s之内不能多次提交。
      const currentTime = +new Date();
      if (
        lastUrl === data.url &&
        lastSend &&
        lastSend + LOCKTIME >= currentTime
      ) {
        return;
      }
      lastUrl = data.url;
      lastSend = currentTime;
      self.getNetState(function (ect) {
        if (ect == 'offline') return;
        if (!WN.onLine) return;
        if (
          WN.connection &&
          WN.connection.rtt == 0 &&
          WN.connection.downlink == 0
        )
          return;
        self.send(
          '//monitor.babytree.com/v5.jpg',
          self.getData({
            ...data,
            ect,
            referrer: encodeURIComponent(W.location.href)
          })
        );
      });
    };
    hook({
      onreadystatechange: function (xhr, event) {
        if (xhr.readyState == xhr.DONE) {
          set(xhr, 'doneTime', +new Date());
          if ((xhr.status >= 500 || xhr.status < 100) && xhr.status != 0) {
            set(xhr, 'msg', 'status');
            newCallback(getData(xhr));
          }
        }
        return false;
      },
      onerror: function (xhr, event) {
        // set(xhr, 'msg', 'error');
        // newCallback(getData(xhr));
        return false;
      },
      ontimeout: function (xhr, event) {
        // set(xhr, 'doneTime', +new Date());
        // set(xhr, 'msg', 'timeout');
        // newCallback(getData(xhr));
        return false;
      },
      //拦截方法
      open: function (args, xhr) {
        set(xhr, 'open_args', args);
        //拦截方法的返回值含义同拦截回调的返回值
        return false;
      },
      send: function (args, xhr) {
        set(xhr, 'sendTime', +new Date());
        //拦截方法的返回值含义同拦截回调的返回值
        return false;
      }
    });
  },
  getNetState: function (callback) {
    const connection = WN.connection;
    const ect =
      connection && connection.effectiveType
        ? connection.effectiveType
        : 'unkown';
    if (!isApp()) {
      callback(ect);
      return;
    }
    const STATEMAP = {
      0: 'offline',
      1: 'wifi',
      2: 'cellular'
    };
    const callName = 'nativeGetNetState';
    const callbackName = 'nativeGetNetStateFinishCall';
    let orginCallback;
    if (W[callbackName]) {
      orginCallback = W[callbackName];
    }
    W[callbackName] = function (data) {
      callback(STATEMAP[data.state] || ect);
      if (orginCallback) {
        W[callbackName] = orginCallback;
      }
    };

    if (W.android) {
      let orginCallbackAndroid;
      if (W.android[callbackName]) {
        orginCallbackAndroid = W.android[callbackName];
      }
      W.android[callbackName] = function (data) {
        callback(STATEMAP[data.state] || ect);
        if (orginCallbackAndroid) {
          W.android[callbackName] = orginCallbackAndroid;
        }
      };
    }

    if (W.Bridge && W.Bridge.postMessage) {
      W.Bridge.postMessage({
        method: callName,
        params: []
      });
      return;
    }

    if (
      W.android &&
      W.android[callName] &&
      typeof W.android[callName] == 'function'
    ) {
      W.android[callName]();
      return;
    }

    if (W[callName] && typeof W[callName] == 'function') {
      W[callName]();
      return;
    }

    callback({
      ect
    });
  },
  /**
   * 向火山监控发送首屏加载时间
   * @param browserClient
   */
  sendFirstScreenTimeEvent: function (browserClient) {
    if (browserClient) {
      getFirstScreenTime().then(data => {
        //console.log('getfst--000--', data);
        if (browserClient && data) {
          browserClient('sendEvent', {
            name: 'bbt_fst',
            metrics: {
              fst: data
            }
          });
        }
      });
    }
  }
};

export default bbtMonitor;
